import React, { FunctionComponent, useCallback } from 'react';
import { Analytics } from '@trello/atlassian-analytics';
import { featureFlagClient } from '@trello/feature-flag-client';
import { SearchIcon } from '@trello/nachos/icons/search';
import { HeaderTestIds } from '@trello/test-ids';
import { Urls } from 'app/scripts/controller/urls';
import { useBoardBackground } from 'app/src/components/Theme';
import { HeaderLink } from './HeaderLink';
import styles from './HeaderSearchButton.less';

export const HeaderSearchButton: FunctionComponent = () => {
  const { backgroundBrightness } = useBoardBackground();
  const onClick = useCallback(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'HeaderSearchButton',
      source: 'appHeader',
      attributes: {
        isCrossProductSearchEnabled: featureFlagClient.get(
          'workflowers.cross-product-search',
          false,
        ),
      },
    });
  }, []);
  return (
    <span className={styles.searchButton}>
      <HeaderLink
        buttonStyle="button"
        className={styles.searchIcon}
        href={Urls.getSearchUrl()}
        onClick={onClick}
        testId={HeaderTestIds.SearchButton}
      >
        <SearchIcon
          color={backgroundBrightness === 'dark' ? 'light' : 'gray'}
          size="medium"
        />
      </HeaderLink>
    </span>
  );
};
